import React from 'react';
import { startCase } from 'lodash';
import { MdCircle } from 'react-icons/md';
import { getPriorityColor } from './api/site';

export const getPriorityForTable = (p) => {
  const priority = p || 'no priority';
  const color = getPriorityColor(p);
  return (
    <div className="flex items-center">
      <MdCircle color={color} className="mr-2" />
      {startCase(priority)}
    </div>
  );
};
